class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => {
      cartItems.handleCartRequestComplete(data);
   if (window.location.pathname === '/cart') {
            location.reload();
          }
    });   
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    
    if (this.tagName === 'CART-ITEMS') {
      this.checkCartThreshold();
    }

    
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  cartHasPromoItem (items, variant_id) {
    var foundItems = items.filter(function (item) {
      return item.variant_id === parseInt(variant_id) && (item.properties && item.properties['_vendor_gwp']);
    });

    return foundItems.length > 0;
  }

  getTotalValueByVendor (items) {
    var totalValueByVendor = {};
    var index;
    for (index = 0; index < items.length; index++) {
      var item = items[index];

      if (item.hasOwnProperty('vendor')) {
        if (totalValueByVendor[item.vendor]) {
          totalValueByVendor[item.vendor] = totalValueByVendor[item.vendor] + item.final_line_price;
        } else {
          totalValueByVendor[item.vendor] = item.final_line_price;
        }
      }
    }

    return totalValueByVendor;
  }

  getCartItemIndex (items, variant_id) {
    var foundItemIndex = null;
    var index;
    for (index = 0; index < items.length; index++) {
      var item = items[index];

      if (item.variant_id === parseInt(variant_id)) {
        if (item.properties && item.properties['_vendor_gwp']) {
          foundItemIndex = index + 1;
          break;
        }
      }
    }

    return foundItemIndex;
  }

  getItemsToAdd (cart, totalValuesByVendor) {
    var itemsToAdd = [];
    var settings = JSON.parse($('#vendor_gwp_settings').html());

    settings.forEach((setting) => {
      var threshold = setting.threshold * 100;

      if (Object.keys(totalValuesByVendor).includes(setting.title)) {
        var itemIsInCart = this.cartHasPromoItem(cart.items, setting.variant_id);

        if (totalValuesByVendor[setting.title] >= threshold && !itemIsInCart) {
          itemsToAdd.push(setting.variant_id);
        }
      }
    });

    return itemsToAdd;
  }

  getItemsToRemove (cart, totalValuesByVendor) {
    var itemsToRemove = [];
    var settings = JSON.parse($('#vendor_gwp_settings').html());

    settings.forEach((setting) => {
      var threshold = setting.threshold * 100;

      if (Object.keys(totalValuesByVendor).includes(setting.title)) {
        var itemIsInCart = this.cartHasPromoItem(cart.items, setting.variant_id);

        if (totalValuesByVendor[setting.title] < threshold && itemIsInCart) {
          var cartItemIndex = this.getCartItemIndex(cart.items, setting.variant_id);
         console.log(cartItemIndex);
          itemsToRemove.push(cartItemIndex);
        }
      }
    });

    return itemsToRemove;
  }

  getItemsToRemoveVid (cart, totalValuesByVendor) {
    var itemsToRemoveVid = [];
    var settings = JSON.parse($('#vendor_gwp_settings').html());

    settings.forEach((setting) => {
      var threshold = setting.threshold * 100;

      if (Object.keys(totalValuesByVendor).includes(setting.title)) {
        var itemIsInCart = this.cartHasPromoItem(cart.items, setting.variant_id);

        if (totalValuesByVendor[setting.title] < threshold && itemIsInCart) {
          var cartItemIndex = this.getCartItemIndex(cart.items, setting.variant_id);

          itemsToRemoveVid.push(cartItemIndex);
        }
      }
    });

    return itemsToRemoveVid;
  }
  
  handleCartRequestComplete (cart) {
    var totalValuesByVendor = this.getTotalValueByVendor(cart.items);
    var itemsToAdd = this.getItemsToAdd(cart, totalValuesByVendor);
    var itemsToRemove = this.getItemsToRemove(cart, totalValuesByVendor);
    var ItemsToRemoveVid = this.getItemsToRemoveVid(cart, totalValuesByVendor);
    var newPropertyName = '_vendor_gwp';
    var newPropertyValue = '_vendor_gwp'
    itemsToAdd.forEach((item) => {
      let formData = {
                   'items': [{
                    'id': item,
                    'quantity': 1,
                     'properties': {}
                    }]
                  };
      if (newPropertyName && newPropertyValue !== null && newPropertyValue !== undefined) {
          formData.items[0].properties[newPropertyName] = newPropertyValue;
        }
              
               fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                  })
                  .then(response => {
                    return response.json();
                  })
                  .then(response =>{
                    this.onCartUpdate();
                  })
    });
    if (itemsToRemove.length > 0) {
      console.log(itemsToRemove);
      itemsToRemove.forEach((itemIndex) => {
      this.updateQuantity(itemIndex, 0, document.activeElement.getAttribute('name'), ItemsToRemoveVid);
    });
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
      fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => {
      this.handleCartRequestComplete(data);
    }); 
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
    
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        
        this.updateLiveRegions(line, message);
        
       if (this.tagName === 'CART-ITEMS') {
          this.checkCartThreshold();
        }else{
           
         fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => {
      this.handleCartRequestComplete(data);
    }); 
          
           jQuery.getJSON('/cart.js', function(cart) { 
  var gwpVariantElement = document.querySelector('.gwp_variant');
  
  // Check if the .gwp_variant element exists
  if (!gwpVariantElement) {
    console.error('Error: .gwp_variant element not found.');
    return; // Stop execution if the element is missing
  }

  var gwpVariantId = parseInt(gwpVariantElement.getAttribute('gwp_variant_id'));
  var gwpThreshold = parseInt(gwpVariantElement.getAttribute('gwp_threshold_price'));
  
  var total_non_gift_card_price = 0;
  var isGiftCardInCart = false;
  var isOtherProductInCart = false;
  var freeProductInCart = false;
  var gwpLineId = null;

  cart.items.forEach(function(item, index) {
    // Check if the free product (GWP) is already in the cart
    if (item.id === gwpVariantId) {
      freeProductInCart = true;
      gwpLineId = item.key; // Use the unique key instead of the index for precise targeting
    }

    // Check if a gift card is in the cart
    if (item.handle === 'smallflower-gift-card') {
      isGiftCardInCart = true;
    }

    // Check if there is any other product (non-gift card and non-GWP) in the cart
    if (item.id !== gwpVariantId && item.handle !== 'smallflower-gift-card') {
      isOtherProductInCart = true;
      total_non_gift_card_price += item.line_price / 100; // Calculate total price excluding gift card and GWP
    }
  });

  console.log(gwpVariantId);
  console.log(isGiftCardInCart);
  console.log(isOtherProductInCart);
  console.log(freeProductInCart);
  console.log(total_non_gift_card_price);

  // If total non-gift-card price exceeds threshold, GWP is not in the cart, and there is at least one other qualifying product (non-gift card)
  if (total_non_gift_card_price >= gwpThreshold && !freeProductInCart && isOtherProductInCart) {
    let formData = {
      'items': [{
        'id': gwpVariantId,
        'quantity': 1
      }]
    };

    // Add the free product (GWP)
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(response => {
      // Update the cart drawer or cart items if necessary
      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      if (cartItems) {
        cartItems.updateQuantity(1, 1);
      }
    });
    console.log(gwpVariantId);
  }
  // If total non-gift-card price is below threshold or no qualifying products are in the cart, and GWP is in the cart, remove the free product
  else if ((total_non_gift_card_price < gwpThreshold || !isOtherProductInCart) && freeProductInCart) {
    let formData = {
      'line': gwpLineId,  // Use the unique key to target the exact line of the GWP
      'quantity': 0
    };

    // Remove the free product (GWP) only
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(response => {
      // Update the cart drawer or cart items if necessary
      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      if (cartItems) {
        cartItems.updateQuantity(1, 0);
      }
    });
    console.log(gwpVariantId);
  }
});
        }
        
        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state
          }
        }));
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  checkCartThreshold(){
  Shopify.Cart = Shopify.Cart || {};
  Shopify.Cart.GiftWrap = {
    refreshCart: function() {
      fetch('/cart?view=ajax')
        .then(response => {
          if (response.ok) {
            return Promise.resolve(response);
          }
          else {
            return Promise.reject(new Error('Failed to load'));
          }
        })
        .then(response => response.text())
        .then(data => {
          let cartDom = document.querySelector('cart-items');

          if(cartDom) {
            cartDom.innerHTML = data;
            var el = cartDom.querySelector('cart-items');
            var parent = document.querySelector('html');
            parent.innerHTML = data;
          }
        })
        .catch(function(error) {
          console.log('Error: ' + error.message);
        });
    },
    set: function(variantid, quantity){
      var headers = new Headers({ 'Content-Type': 'application/json' });

      var request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ id : variantid, quantity: quantity })
      };
      fetch('/cart/add.js', request)
        .then(function() {
          // Handle success
        });
      setTimeout(() => {
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => response.json())
          .then(data => { data; this.refreshCart(); });
      }, 300);
    },
    remove: function(productId){
      $.ajax({
        method: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          quantity: 0,
          id: productId
        }
      }).then(function(result) {
        // Handle success
      });
      setTimeout(() => {
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => response.json())
          .then(data => { data; this.refreshCart(); });
      }, 300);
    }
  };

  jQuery.getJSON('/cart.js', function(cart) {
    var total_price = cart.total_price / 100;
    var giftCardInCart = false;
    var p;
    var otherProductsInCart = false; // Track if other products are in the cart
    var gwpVariantId = parseInt(document.querySelector('.gwp_variant').getAttribute('gwp_variant_id'));
    var gwpThreshold = parseInt(document.querySelector('.gwp_variant').getAttribute('gwp_threshold_price'));

    cart.items.forEach(function(item) {
        if (item.id === gwpVariantId) {
            p = item.id;
        }
        var giftCardIds = [
            37172735049879, 37172735082647, 37172735115415, 37172735148183,
            37172735180951, 37172735213719, 37172735246487, 37172735279255,
            37172735312023, 37172735344791, 37172735377559, 37172735410327,
            41556310392983
        ];
        if (giftCardIds.includes(item.id)) {
            giftCardInCart = true;
        } else if (item.id !== gwpVariantId) {
            otherProductsInCart = true;
        }
    });

    console.log(total_price);
    console.log(gwpThreshold);
    console.log(giftCardInCart);
    console.log(otherProductsInCart);

    if (total_price >= gwpThreshold && p !== gwpVariantId && otherProductsInCart) {
        Shopify.Cart.GiftWrap.set(gwpVariantId, 1);
    } else if ((total_price < gwpThreshold || !otherProductsInCart) && p === gwpVariantId) {
        Shopify.Cart.GiftWrap.remove(gwpVariantId);
    }
});

}
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
